import { PUT_REDUX_COMPANIES_LIST } from '../../reducers/constants';

const putReduxCompanies = (companiesList) => ({
  type: PUT_REDUX_COMPANIES_LIST,
  companiesList,
});

export default putReduxCompanies;
